import React, {
    Component
} from "react";
// import 'antd/dist/antd.css';
import $ from "jquery";
import NodeParaEdit from "./NodeParaEdit";
import { Row, Col, Modal, Button } from "antd";
// import {render} from 'react-dom'
// var jtopo = $('<script src="jtopo-0.4.8-min.js" type="text/javascript"></script>');
// $(document.body).before(jtopo);
const JTopo = window.JTopo;
const STARTNODETYPE = "01";

class Workflow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editpanelWidth: 24,
            nodepanelWidth: 0,
            root: undefined,
            over: undefined,
            w: this.props.width != null && typeof (this.props.width) !== "undefined" ? this.props.width : "100%",
            h: this.props.height != null && typeof (this.props.height) !== "undefined" ? this.props.height : "790px",
            canvas: undefined,
            code: this.props.code != null && typeof (this.props.code) !== "undefined" ? this.props.code : "workflowEditPanel",
            canvasid: this.props.code != null && typeof (this.props.code) !== "undefined" ? "canvas" + this.props.code : "canvasworkflowEditPanel",
            editid: this.props.code != null && typeof (this.props.code) !== "undefined" ? "editid" + this.props.code : "canvaseditidPanel",
            currnode: null,
            currdata: null,
            maxid: 1,
            contextmenu: this.props.ctxmenu != null && typeof (this.props.ctxmenu) !== "undefined" ? this.props.ctxmenu : [{
                text: "添加任务",
                pk: "1",
                img: "./images/task_done.png",
                func: function (wf) {
                    wf.rmenuClick(wf, "06");
                }
            }, {
                text: "添加跳转",
                pk: "2",
                img: "./images/jump_done.png",
                func: function (wf) { wf.rmenuClick(wf, "02"); }
            }, {
                text: "添加服务",
                pk: "3",
                img: "./images/service_done.png",
                func: function (wf) {
                    wf.rmenuClick(wf, "03");
                }
            }, {
                text: "添加脚本",
                img: "./images/script_done.png",
                pk: "4",
                func: function (wf) { wf.rmenuClick(wf, "04"); }
            }, {
                text: "添加子流程",
                pk: "5",
                img: "./images/workflow_done.png",
                func: function (wf) { wf.rmenuClick(wf, "05"); }
            }, {
                text: "添加终点",
                pk: "6",
                img: "./images/over.png",
                func: function (wf) { wf.rmenuClick(wf, "99"); }
            }, {
                text: "删除节点",
                pk: "7",
                img: "./images/delete.png",
                func: function (wf) {
                    var node = wf.state.currnode;
                    if (!node) {
                        alert("no selected node");
                        return;
                    }
                    node.remove();
                }
            }],
            config: {},
            clickfunction: this.props.clickFunc != null && typeof (this.props.clickFunc) !== "undefined" ? this.props.clickFunc : this.clickFunc,
            blankClickFunc: this.props.blankClickFunc != null && typeof (this.props.blankClickFunc) !== "undefined" ? this.props.blankClickFunc : this.blankClickFunc,
            model: this.props.model != null && typeof (this.props.model) !== "undefined" ? this.props.model : null,
            readOnly: this.props.readOnly != null && typeof (this.props.readOnly) !== "undefined" ? this.props.readOnly : true,
            debug: this.props.debug != null && typeof (this.props.debug) !== "undefined" ? this.props.debug : false,

        };
    }
    clickfunction(node, model) { }
    sceneClickFcuntion() { }
    init() {
        var baseDom = document.getElementById(this.state.canvasid);
        var editpanel = document.getElementById(this.state.editid);
        tool.sgiLogger.log(baseDom);
        tool.sgiLogger.log(editpanel);
        baseDom.width = editpanel.clientWidth;
        baseDom.height = editpanel.clientHeight;
        this.canvas = this.scene(baseDom);
        if (this.state.model) {
            if (!this.maxid) { this.maxid = 0; }
            this.drawRoot(this.state.model, this.state.readOnly);
            this.maxid++;
        } else {
            if (!this.maxid) { this.maxid = 1; }
            var start = this.newData(null, "01");
            this.drawRoot(start);
        }
    }

    scene(domNode) {
        var me = this;
        var stage = new JTopo.Stage(domNode); // 创建一个舞台对象
        var scene = new JTopo.Scene(stage); // 创建一个场景对象
        stage.wheelZoom = 0.9;
        scene.mode = "normal";
        if (me.readOnly) { stage.mode = "drag"; }
        stage.wheelZoom = null;
        stage.click(function (event) {
            // 关闭弹出菜单（div）
            me._hideMenu("ctxmenu");
            if (!me.nodeclick) { // 标识这次执行的是空白处的点击事件
                me.sceneClickFcuntion();
            }
            me.nodeclick = false;
        });
        return scene;
    }
    drawRoot(model, type) {
        var me = this;
        if (!this.canvas) {
            me.init();
        }
        // this.root:model});
        var jumps = [];
        var nodes = [];
        var draw = function (model) {
            if (!model) { return; }
            var node = me.getnode(model, model.type, type);
            if (model.type === "01") {
                // me.root=node;
                // me.currnode=node;
                me.setState({ root: node, currnode: node });
            }
            if (!node) {
                tool.sgiLogger.log("create node failed," + model);
                return undefined;
            }
            nodes.push(node);
            me.canvas.add(node);
            var children = model.childNode;
            if (!children) {
                if (model.type === "02") { jumps.push(node); }
                if (!me.maxid) { me.maxid = 0; }
                if (node.data.id > me.maxid) { me.maxid = node.data.id; }
                tool.sgiLogger.log(model.name + " no children");
                return node;
            }
            var downnodes = [];
            for (var i = 0; i < children.length; i++) {
                var n = draw(children[i]);
                if (n) {
                    if (!n.parentsNode) { n.parentsNode = []; }
                    n.parentsNode.push(node);
                    downnodes.push(n);
                }
            }
            node.to = downnodes;
            for (var j = 0; j < downnodes.length; j++) {
                var link = me.line(node, downnodes[j]);
                if (link) {
                    me.canvas.add(link);
                }
            }
            if (!me.maxid) { me.maxid = 0; }
            if (node.data.id > me.maxid) { me.maxid = node.data.id; }
            // if (node.data.type==="02") jumps.push(node);
            return node;
        };
        var node = draw(model);
        for (var n = 0; n < jumps.length; n++) {
            var jpnode = jumps[n];
            for (var m = 0; m < nodes.length; m++) {
                tool.sgiLogger.log(nodes[m].id);
                if (jpnode.data.ncode === nodes[m].data.id) {
                    var link = me.dottedline(jpnode, nodes[m]);
                    jpnode.dotline = link;
                    me.canvas.add(link);
                    break;
                }
            }
        }
        return node;
    }
    clear() {
        if (this.canvas) {
            this.canvas.clear();
        }
    }
    create(currentNode, model) {
        if (!model) {
            return;
        }
        var me = this;
        if (!this.canvas) {
            me.init();
        }
        var node = me.getnode(model, model.type);
        if (model.type === "01") {
            // me.root = node
            // me.currnode = node
            me.setState({ root: node, currnode: node });
        }
        if (!node) {
            tool.sgiLogger.log("unsupport node type : " + model.type);
            return;
        }
        if (currentNode && node) {
            me.canvas.add(node);
            var link = me.line(currentNode, node);
            me.canvas.add(link);
        }
        return node;
    }
    remove(node) {
        var me = this;

        if (node.data && node.data.type && node.data.type === "02") {

            var dotline = node.dotline;
            if (me.canvas && dotline) {
                me.canvas.remove(dotline);
            }
            if (dotline.nodeA && dotline.nodeA.type === "temp") {
                me.canvas.remove(dotline.nodeA);
            }

            if (dotline.nodeZ && dotline.nodeZ.type === "temp") {
                me.canvas.remove(dotline.nodeZ);
            }
        }
        if (me.canvas) {
            if (node.fromlines && node.fromlines.length > 0) {
                node.fromlines.forEach((line) => {
                    if (line.nodeA && line.nodeA.type === "temp") {
                        me.canvas.remove(line.nodeA);
                        me.canvas.remove(line);
                    }

                    if (line.nodeZ && line.nodeZ.type == "temp") {
                        me.canvas.remove(line.nodeZ);
                        me.canvas.remove(line);
                    }
                });
            }

            if (node.tolines && node.tolines.length > 0) {
                node.tolines.forEach((line) => {
                    if (line.nodeA && line.nodeA.type === "temp") {
                        me.canvas.remove(line.nodeA);
                        me.canvas.remove(line);
                    }

                    if (line.nodeZ && line.nodeZ.type === "temp") {
                        me.canvas.remove(line.nodeZ);
                        me.canvas.remove(line);
                    }
                });
            }

            me.canvas.remove(node);
        }
    }

    line(fromNode, toNode) {
        var me = this;
        var line = new JTopo.Link(fromNode, toNode);

        line.lineWidth = 2; // 线宽
        line.arrowsRadius = 7; // 箭头大小
        line.textOffsetY = 3; // 文本偏移量(向下3个像素)
        // line.strokeColor = "240,131,31";

        line.strokeColor = "28 28 28";
        // line.bundleOffset = 60; // 折线拐角处的长度
        // line.bundleGap = 20; // 线条之间的间隔

        fromNode.setToline(line);
        toNode.setFromline(line);

        if (!me.state.readOnly) {
            line.addEventListener("dbclick", function (e) {
                // var anode = this.nodeA;
                // var tempstart = me.lineStartNode(anode.x, anode.y, this);


                var anode = this.nodeA;
                var znode = this.nodeZ;

                if (znode && line.nodeZ.type != "temp" && anode && line.nodeA.type != "temp") {
                    var tempstart = me.lineEndNode(znode.x - 35, znode.y, this);
                    me.canvas.add(tempstart);
                    for (var i = 0; i < anode.tolines.length; i++) {
                        if (anode.tolines[i].nodeA == anode && anode.tolines[i].nodeZ == tempstart) {
                            // anode.tolines[i].nodeZ = tempstart;
                            if (anode.data.childNode) { anode.data.childNode.splice(i, 1); }
                        }
                    }
                    for (var i = 0; i < znode.fromlines.length; i++) {

                        if (znode.fromlines[i].nodeA == anode && znode.fromlines[i].nodeZ == tempstart) {
                            // anode.tolines[i].nodeZ = tempstart;
                            znode.fromlines.splice(i, 1);
                        }

                    }
                }
                // if (znode&& line.nodeZ.type!="temp" && anode && line.nodeA.type == "temp") {
                //     tempstart = me.lineEndNode(znode.x, znode.y, this);
                //     me.canvas.add(tempstart);
                //     for (let i = 0; i < anode.tolines.length; i++) {
                //         if (anode.tolines[i].nodeA == anode && anode.tolines[i].nodeZ == znode) {
                //             anode.tolines[i].nodeZ=tmpstart;
                //             if (anode.data.childNode) { anode.data.childNode.splice(i, 1) };
                //         }
                //     }
                // }
                // if (anode && line.nodeA.type != "temp") {
                //     for (let i = 0; i < anode.tolines.length; i++) {
                //         if (anode.tolines[i].nodeA == anode && anode.tolines[i].nodeZ == znode) {
                //             anode.tolines[i].nodeZ=tmpstart;
                //             if (anode.data.childNode) { anode.data.childNode.splice(i, 1) };
                //         }
                //     }

                //     // Ext.Array.remove(anode.tolines ,this);
                //     // anode.tolines.splice($.inArray(this, anode.tolines), 1);

                //     // var childnodes = anode.data.childNode;
                //     // if (childnodes) {
                //     // // Ext.Array.remove(childnodes ,znode.data);
                //     //     childnodes.splice($.inArray(anode.data, childnodes), 1);
                //     // //anode.data.cldSet = childnodes;
                //     // }
                // }

            });
        }

        return line;
    }
    dottedline(fromNode, toNode) {
        var link = this.line(fromNode, toNode);
        link.dashedPattern = 5; // 虚线
        return link;
    }
    lineStartNode(x, y, line) {
        var me = this;
        var lsn = me._tempNode(x, y);

        line.nodeA = lsn;
        lsn.toline = line;

        return lsn;
    }
    lineEndNode(x, y, line) {
        var me = this;
        var len = me._tempNode(x, y);

        line.nodeZ = len;
        len.fromline = line;

        return len;
    }
    jumpLine(node) {
        var me = this;
        let temp = me._tempNode(node.x + 130, node.y + 30);
        temp.addEventListener("mousedrag", function (e) {
            // me.dragnode = this;
            me.setState({ dragnode: this });
        });
        var dotline = me.dottedline(node, temp);

        dotline.nodeZ = temp;
        temp.fromline = dotline;

        this.canvas.add(temp);
        this.canvas.add(dotline);

        node.dotline = dotline;

        return dotline;
    }
    _addNodeListener(node) {
        var me = this;
        node.addEventListener("click", function (e) {
            // if (!me.nodedrag) {
            //     me.state.clickfunction(node, me);
            //     me.nodeclick = true; // 标识这次执行的是node的点击事件
            // }
            // me.nodedrag = false;
        });
        node.addEventListener("dbclick", function (e) {
            me.state.clickfunction(node, me);
        });
        node.addEventListener("mouseup", function (e) {
            if (e.button === 2) { // 右键
                me.rclickFunc(node);
                me._showMenu(this, "ctxmenu");
            }
        });
        node.addEventListener("mousedown", function (e) {
            // tool.sgiLogger.log("mousedown:"+this);
        });
        node.addEventListener("mouseover", function (e) {

            if (me.state.dragnode) {
                var current = this;
                var temp = me.state.dragnode;
                var line;
                if (temp.toline) {
                    line = temp.toline;
                    // var downNode = line.nodeZ;
                    var tonode = line.nodeZ;
                    if (tonode && tonode.type != "temp") {
                        // var childnodes = current.data.cldSet;

                        for (let i = 0; i < tonode.fromlines.length; i++) {
                            if (tonode.fromlines[i].nodeA == current && tonode.fromlines[i].nodeZ == tonode) {
                                return;
                            }
                        }

                        current.setToline(line);
                        var childnodes = current.data.childNode;
                        if (!childnodes) {
                            childnodes = [];
                            // current.data.cldSet = childnodes;
                            current.data.childNode = childnodes;
                        }
                        childnodes.push(tonode.data);
                    }
                } else {
                    line = temp.fromline;
                    var upNode = line.nodeA;
                    if (current == upNode) {
                        return;
                    }
                    for (let i = 0; i < upNode.tolines.length; i++) {
                        if (upNode.tolines[i].nodeA == upNode && upNode.tolines[i].nodeZ == current) {
                            return;
                        }
                    }
                    for (let i = 0; i < current.fromlines.length; i++) {
                        if (current.fromlines[i].nodeA == upNode && current.fromlines[i].nodeZ == current) {
                            return;
                        }
                    }
                    current.setFromline(line);
                    if (upNode && upNode.type != "temp" && upNode.data.type != "02") {
                        var childnodes = upNode.data.childNode;
                        if (childnodes) { childnodes.push(current.data); }


                        // upNode.data.gotoNodeId = current.data.id;
                        // upNode.data.ncode = current.data.id;
                    }
                    if (upNode && upNode.type != "temp" && upNode.data.type == "02") {

                        upNode.data.gotoNodeId = current.data.id;
                        upNode.data.ncode = current.data.id;
                        upNode.click();
                        if (me.refs.NodeParaEdit.refs.jumppanel) { me.refs.NodeParaEdit.refs.jumppanel.setFieldsValue({ ncode: upNode.data.ncode }); }
                    }
                    // upNode.data.transfer = current.data.sc ;

                }
                me.remove(temp);
                me.setState({ dragnode: undefined });
            }
        });
        node.addEventListener("mousedrag", function (e) {
            if (this.data) {
                if ((this.data.x !== this.x) || (this.data.y !== this.y)) {
                    me.setState({ nodedrag: true });
                }
                this.data.x = this.x;
                this.data.y = this.y;
            }

        });


    }
    _setModelPubFiedls(model, node) {
        var me = this;
        node.data = model;
        node.createNextNode = function (data) {
            return me.create(this, data);
        };
        node.remove = function () {
            var delNode = this;
            var downlines = delNode.tolines;
            if (downlines) {
                for (var i = 0; i < downlines.length; i++) {
                    var line = downlines[i];
                    var tempstart = me.lineStartNode(delNode.x, delNode.y, line);
                    me.canvas.add(tempstart);
                }
            }
            delNode.tolines = [];

            if (typeof (me.state.over) !== "undefined" && delNode.type === "99") {
                me.setState({ over: undefined });
            }
            me.remove(delNode);
            var pnodes = delNode.parentsNode;
            if (pnodes) {
                for (var j = 0; j < pnodes.length; j++) {
                    if (pnodes[j].data.childNode) {
                        for (var i = 0; i < pnodes[j].data.childNode.length; i++) {
                            if (pnodes[j].data.childNode[i].id === delNode.data.id) {
                                pnodes[j].data.childNode.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
                for (var j = 0; j < pnodes.length; j++) {
                    var downlines = pnodes[j].tolines;
                    if (downlines) {
                        for (var i = 0; i < downlines.length; i++) {
                            var line = downlines[i];
                            if (line.nodeZ === delNode) {
                                pnodes[j].tolines.splice(i, 1);
                            }
                        }
                    }
                }
            }
        };
        node.setToline = function (line) {
            if (!this.tolines) {
                this.tolines = [];
            }
            this.tolines.push(line);

            line.nodeA = this;
        };
        node.setFromline = function (line) {
            if (!this.fromlines) {
                this.fromlines = [];
            }
            this.fromlines.push(line);

            line.nodeZ = this;
        };
        node.getChart = function () {
            return me;
        };

        node.id = model.sc;
    }
    getnode(model, nodetype, type) {
        var nodetypes = ["01", "02", "03", "04", "05", "06", "99"];
        if (nodetypes.indexOf(nodetype) < 0) {
            return null;
        }
        var name;
        switch (nodetype) {
            case "01":
                name = "开始";
                break;
            case "02":
                name = "跳转节点";
                break;
            case "03":
                name = "服务节点";
                break;
            case "04":
                name = "脚本节点";
                break;
            case "05":
                name = "子流程";
                break;
            case "06":
                name = "任务节点";
                break;
            case "99":
                name = "结束";
                break;

            default:
                break;
        }
        // var node = new JTopo.Node(model.id + " " + name);
        // if (!node) {
        //     return node;
        // }
        // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
        // node.font = "12px Consolas";
        // node.fontColor = "0 ,0 ,0";
        // // node.textPosition = "Middle_Center";
        // node.setSize(38, 38);
        // if (nodetype) {node.type = nodetype;}
        // if (!model.name) {model.name = name;}
        // if (nodetype === "01") {
        //     node.setImage(require("./images/start.png"));
        // } else if (nodetype === "99") {
        //     node.setText = function (str) {
        //         if (!str) {
        //             this.text = name;
        //         }
        //         this.text = str;
        //     };
        //     node.setImage(require("./images/over.png"));
        //     if (type && model && model.status && model.status === "00") {
        //         node.setImage(require("./images/over_undo.png"));
        //     } else if (model && model.status && model.status === "02") {
        //         node.setImage(require("./images/over.png"));
        //     }
        //     this.setState({over: node});
        // } else {
        //     node.setText = function (str) {
        //         if (!str) {
        //             this.text = name;
        //         }
        //         this.text = str;
        //     };
        //     if (model && model.name) {node.setText(model.id + " " + model.name);}
        //     if (nodetype === "02") {
        //         node.fillColor = "255 ,255 ,0";
        //         node.setImage(require("./images/jump_done.png"));
        //         if (type && model && model.status && model.status === "00") {
        //             node.setImage(require("./images/jump_undo.png"));
        //         } else if (model && model.status && model.status === "02") {
        //             node.fontColor = "30 144 255";
        //         }

        //     }
        //     if (nodetype === "03") {
        //         node.fillColor = "218 ,112 ,214";
        //         node.setImage(require("./images/service_done.png"));
        //         if (type && model && model.status && model.status === "00") {
        //             node.setImage(require("./images/service_undo.png"));
        //         } else if (model && model.status && model.status === "02") {
        //             node.fontColor = "30 144 255";
        //         }

        //     }
        //     if (nodetype === "04") {
        //         node.fillColor = "250 ,235 ,215";
        //         node.setImage(require("./images/script_done.png"));
        //         if (type && model && model.status && model.status === "00") {
        //             node.setImage(require("./images/script_undo.png"));
        //         } else if (model && model.status && model.status === "02") {
        //             node.fontColor = "30 144 255";
        //         }

        //     }

        //     if (nodetype === "05") {
        //         node.fillColor = "188 ,143 ,143";
        //         node.setImage(require("./images/workflow_done.png"));
        //         if (type && model && model.status && model.status === "00") {
        //             node.setImage(require("./images/workflow_undo.png"));
        //         } else if (model && model.status && model.status === "02") {
        //             node.fontColor = "30 144 255";
        //         }

        //     }
        //     if (nodetype === "06") {
        //         node.fillColor = "127 ,255 ,212";
        //         node.setImage(require("./images/task_done.png"));
        //         if (type && model && model.status && model.status === "00") {
        //             node.setImage(require("./images/task_undo.png"));
        //         } else if (model && model.status && model.status === "02") {
        //             node.fontColor = "30 ,144 ,255";
        //         }

        //     }
        // }
        let node = new JTopo.Node(model.id + " " + name);
        if (!node) {
            return node;
        }
        // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
        node.font = "12px Consolas";
        node.textPosition = "Middle_Center"; // 文字居中
        node.fontColor = "0 ,0 ,0";
        // node.borderRadius = 5; // 圆角
        node.borderWidth = "1"; // 边框的宽度
        node.borderColor = "255,255,255"; // 边框颜色
        node.alpha = 0.9; // 透明度
        // node.textPosition = "Middle_Center";
        // node.setSize(58, 58);
        if (nodetype) { node.type = nodetype; }
        if (!model.name) { model.name = name; }
        if (nodetype === STARTNODETYPE || nodetype === "99") {
            node.beginDegree = 0;
            node.width = node.height = 80;
            node.paint = function (g) {
                g.beginPath();
                g.moveTo(0, 0);
                g.fillStyle = "rgba(255,140,0," + this.alpha + ")";
                g.arc(
                    0,
                    0,
                    this.width / 2,
                    this.beginDegree,
                    this.beginDegree + 2 * Math.PI
                );
                g.fill();
                g.closePath();

                g.save();
                g.beginPath();
                g.fillStyle = "rgba(255,239,213," + this.alpha + ")";
                g.moveTo(0, 0);
                g.arc(
                    0,
                    0,
                    this.width / 2 - 2,
                    this.beginDegree,
                    this.beginDegree + 2 * Math.PI
                );
                g.fill();
                g.closePath();
                g.restore();

                this.paintText(g);
            };

            // node.textOffsetY = 8; // 文本偏移量(向下3个像素)
            node.font = "12px Consolas";
            node.textPosition = "Middle_Center"; // 文字居中
            node.fontColor = "0 ,0 ,0";
            // node.setSize(58, 58);
            if (nodetype) { node.type = nodetype; }
            if (!model.name) { model.name = name; }
            node.radius = 50; // 半径
            node.borderColor = "255,140,0"; // 边框颜色
            node.fillColor = "	255,239,213"; // 边框颜色
            // node.setImage(require('./images/start.png'));
            if (nodetype === "99") {
                this.setState({ over: node });
            }
        } else {
            node.borderWidth = 1; // 边框的宽度
            node.setText = function (str) {
                if (!str) {
                    this.text = name;
                }
                this.text = str;
            };
            if (model && model.name) { node.setText(model.id + " " + model.name); }
            if (nodetype === "02") {
                // node.fillColor = '255 ,255 ,0';
                node.setSize(70, 70);
                // node.rotate=45*Math.PI/180;
                node.borderRadius = 5; // 圆角
                node.fillColor = "127,255,170";
                node.borderColor = "50,205,50"; // 边框颜色
                // node.setImage(require('./images/jump_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/jump_undo.png"));
                    node.fillColor = "119,136,153";
                    node.alpha = 100;
                    node.borderColor = "105,105,105";
                } else if (model && model.status && model.status === "02") {
                    node.alpha = 100;
                    node.fontColor = "30,144,255";
                }
            }
            if (nodetype === "03") {
                node.setSize(100, 60);
                node.borderRadius = 5; // 圆角
                node.fillColor = "250,128,114";
                node.borderColor = "255,0,0"; // 边框颜色
                // node.setImage(require('./images/service_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/service_undo.png"));
                    node.fillColor = "119,136,153";
                    node.alpha = 100;
                    node.borderColor = "105,105,105";
                } else if (model && model.status && model.status === "02") {
                    node.alpha = 100;
                    node.fontColor = "30,144,255";
                }
            }
            if (nodetype === "04") {
                node.fillColor = "250 ,235 ,215";
                node.setSize(100, 60);
                node.borderRadius = 27; // 圆角
                node.fillColor = "255,20,147";
                node.borderColor = "255,215,0"; // 边框颜色
                // node.setImage(require('./images/script_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/script_undo.png"));
                    node.fillColor = "119,136,153";
                    node.alpha = 100;
                    node.borderColor = "105,105,105";
                } else if (model && model.status && model.status === "02") {
                    node.alpha = 100;
                    node.fontColor = "30,144,255";
                }
            }

            if (nodetype === "05") {
                node.fillColor = "188 ,143 ,143";
                node.setSize(110, 60);
                node.borderRadius = 30; // 圆角
                node.fillColor = "	221,160,221";
                node.borderColor = "148,0,211"; // 边框颜色
                // node.setImage(require('./images/workflow_done.png'));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/workflow_undo.png"));
                    node.fillColor = "119,136,153";
                    node.alpha = 100;
                    node.borderColor = "105,105,105";
                } else if (model && model.status && model.status === "02") {
                    node.alpha = 100;
                    node.fontColor = "30,144,255";
                }
            }
            if (nodetype === "06") {
                // node.fillColor = "135 206 250";
                node.setSize(100, 60);
                node.borderRadius = 20; // 圆角
                node.fillColor = "142,229,238";
                node.borderColor = "30,144,255"; // 边框颜色
                // node.setImage(require("./images/task_done.png"));
                if (type && model && model.status && model.status === "00") {
                    // node.setImage(require("./images/task_undo.png"));
                    node.fillColor = "119,136,153";
                    node.alpha = 100;
                    node.borderColor = "105,105,105";
                } else if (model && model.status && model.status === "02") {
                    node.alpha = 100;
                    node.fontColor = "30,144,255";
                }
            }
        }
        node.setLocation(model.x, model.y);
        this._setModelPubFiedls(model, node);
        if (!type) {
            tool.sgiLogger.log("编辑模式");
            this._addNodeListener(node);
        } else {
            tool.sgiLogger.log("只读模式");
            tool.sgiLogger.log("model.status", model, model.status);

            // 当前执行节点  加特殊标识
            if (model && model.status) {
                node.percent = 0.8;
                node.beginDegree = 0;
                if (model.status === "01" || model.status === "99") {
                    if (model.status === "01") { node.color = "rgba(0,255,0,"; }
                    if (model.status === "99") { node.color = "rgba(255,0,0,"; }
                    // if (model.status === "03") node.color='rgba(143,153,159,';
                    // if (model.status === "04") node.color='rgba(245,255,0,' ;
                    // if (model.status === "05") node.color='rgba(244,248,244,';
                    // if (model.status === "02") node.color='rgba(30 ,144 ,255,' ;
                    if (model.status != "01") {
                        node.percent = 1;
                    } else {
                        node.width = node.height = 80;
                        node.percent = 1;
                    }
                    // node.paint = function (g) {
                    //     //
                    //     g.save();
                    //     g.beginPath();
                    //     g.moveTo(0, 0);
                    //     g.strokeStyle = this.color + this.alpha + ")";
                    //     g.lineWidth = 6;
                    //     g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI * this.percent);
                    //     // g.fill();
                    //     g.stroke();
                    //     g.closePath();
                    //     g.beginPath();
                    //     g.moveTo(0, 0);
                    //     // g.drawImage(this.image, -this.width / 2, -this.height / 2, 38, 38);
                    //     // g.fillStyle = 'rgba(0,0,255,' + this.alpha + ')';
                    //     // g.moveTo(0,0);
                    //     // g.arc(0, 0, this.width/2-8, this.beginDegree, this.beginDegree + 2*Math.PI);
                    //     // g.fill();
                    //     g.closePath();
                    //     g.restore();
                    //     this.paintText(g);
                    // };

                    node.paint = function (g) {
                        //
                        g.save();
                        g.beginPath();
                        g.moveTo(0, 0);
                        g.strokeStyle = this.color + this.alpha + ")";
                        g.lineWidth = 7;
                        g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI * this.percent, true);
                        g.stroke();
                        g.closePath();

                        g.beginPath();
                        g.moveTo(0, 0);
                        g.fillStyle = "rgba(30,144,255," + 100 + ")";
                        g.arc(0, 0, (this.width + 3) / 2, this.beginDegree, this.beginDegree + 2 * Math.PI, true);
                        g.fill();
                        g.closePath();

                        g.restore();
                        this.paintText(g);
                    };

                    if (model.status === "01") {
                        tool.sgiLogger.log("进入画圈环节！！")
                        JTopo.Animate.stepByStep(node, {
                            percent: 0
                        }, 2500, true).start();
                        tool.sgiLogger.log("画圈环节结束！！")
                    }
                }
            }
        }
        return node;
    }
    _tempNode(x, y) {
        var me = this;

        var temp = new JTopo.CircleNode("连接点");
        temp.type = "temp";
        temp.fillColor = "255 ,255 ,0";
        temp.setLocation(x, y);
        temp.radius = 5;

        temp.setFromline = function (line) {
            if (!this.fromlines) {
                this.fromlines = [];
            }
            this.fromlines.push(line);

            line.nodeZ = this;
        };
        temp.setToline = function (line) {
            if (!this.tolines) {
                this.tolines = [];
            }
            this.tolines.push(line);

            line.nodeA = this;
        };

        temp.addEventListener("mousedrag", function (e) {
            me.setState({ dragnode: this });
        });

        temp.addEventListener("mouseout", function (e) {
            // me.dragnode = undefined;
        });

        return temp;
    }
    _createMenu(id, items, node, event) {
        if (!items) {
            return;
        }
        var e = event || window.event;
        var me = this;
        var child = document.getElementById(id);
        if (child) { child.parentNode.removeChild(child); }

        var wrapUl = document.createElement("ul");
        wrapUl.setAttribute("id", id);
        wrapUl.setAttribute("style", "position:fixed;top:" + e.clientY + "px;left:" + e.clientX + "px;width:100px;border-radius:3px;border:1px solid rgb(120, 120, 120);padding:0;margin:0;box-shadow:2px 2px 10px 0px rgb(200,200,200);font-size: 13px;");
        for (var i = 0; i < items.length; i++) {
            if (node.type === "01" && (items[i].pk >= "7")) { continue; }
            if (node.type === "99" && (items[i].pk < "7")) { continue; }
            if (node.type === "02" && (items[i].pk < "7")) { continue; }
            if (typeof (this.over) !== "undefined" && (items[i].pk === "6")) { continue; }
            var item = document.createElement("li");
            item.setAttribute("style", "list-style-type:none;width:100px;background-color:rgb(240,240,240);");
            var inneritem = document.createElement("a");
            inneritem.onmouseover = function () {
                this.style.backgroundColor = "rgb(80,143,224)";
                this.style.color = "white";
            };
            inneritem.onmouseout = function () {
                this.style.backgroundColor = "rgb(240,240,240)";
                this.style.color = "";
            };
            inneritem.setAttribute("style", "margin:0 auto;border-bottom:1px solid rgb(210, 210, 210);display:block;width:100px;padding:2px 0 2px 2px;fontSize:14px;font-weight:400;background-color:rgb(240,240,240);");
            inneritem.innerHTML = "<img src='" + items[i].img + "' style='height:25px;width:25px'/>" + items[i].text;
            inneritem.func = items[i].func;
            inneritem.onclick = function () {
                this.func(me);
                me._hideMenu("ctxmenu");
            };
            item.appendChild(inneritem);
            wrapUl.appendChild(item);
        }
        document.body.appendChild(wrapUl);
    }
    _showMenu(node, id, event) {
        var e = event || window.event;
        this._createMenu(id, this.state.contextmenu, node);
    }
    _hideMenu(id) {
        if (document.getElementById(id)) {
            document.getElementById(id).style.display = "none";
        }
    }
    /** *
     * 节点点击事件
     */
    rclickFunc(node) {
        this.setState({ currnode: node });
        this.setState({ currdata: node.data });
    }
    clickFunc(node, wf) {
        // var me=this;
        // tool.sgiLogger.log(node);
        // var oldnode = this.state.currnode;
        wf.setState({ currnode: node });
        wf.setState({ currdata: node.data });
        // 显示编辑界面
        wf.refs.NodeParaEdit.showDrawer(node);
    }
    blankClickFunc() {
        this.setState({ currnode: null });
        // this.currnode = null;
        this.refs.NodeParaEdit.onClose();
        // this.dragnode =null;
    }
    rmenuClick(wf, type) {
        var node = wf.state.currnode;
        if (!node) {
            alert("no selected node");
            return;
        }

        if (type === "99" && typeof (this.state.over) !== "undefined") {
            alert("已有结束节点，请使用跳转节点结束流程");
            return;
        }


        var data = wf.newData(node, type);
        var nexnode = node.createNextNode(data);

        if (nexnode.parentsNode == null || typeof (nexnode.parentsNode) === "undefined") { nexnode.parentsNode = []; }
        nexnode.parentsNode.push(node);
        if (!node.data.childNode) {
            node.data.childNode = [];
        }
        node.data.childNode.push(data);
        if (type === "02") {
            var chart = node.getChart();
            chart.jumpLine(nexnode);

        }
    }
    render() {
        return (
            // <div style={{ height:'790px',width: '100%' }} >
            <div ref="Workflow" style={{ height: this.state.h, width: this.state.w }} >
                <Row style={{ height: "90%", width: "100%" }}>
                    <Col span={this.state.editpanelWidth} style={{ height: "100%" }}>
                        <div id={this.state.editid} style={{ backgroundColor: "#6c757d", height: "100%" }}>
                            <canvas id={this.state.canvasid} style={{ height: "100%", backgroundColor: "#6c757d", width: "100%" }}> </canvas>
                        </div>
                    </Col>
                </Row>
                <NodeParaEdit ref="NodeParaEdit" node={this.state.currnode} nodedata={this.state.currdata}></NodeParaEdit>
                {this.state.debug
                    ? <Row style={{ height: "10%", width: "100%" }}>
                        <Button type="primary" onClick={this.getData.bind(this)}>查看流程配置</Button>
                        <Button>测试流程</Button>
                    </Row>
                    : ""}
            </div>
        );
    }
    componentDidMount() {
        var me = this;
        if (!me.state.canvas) {
            me.init();
        }
    }
    // newData(node,type){
    //     var x=50, y=30;
    //     if (node) {
    //         x = node.x + 150;
    //         if (node.data.childNode) y = node.y + node.data.childNode.length * 70;
    //         else y = node.y;
    //     }
    //     var data={
    //         id: this.maxid++,
    //         name: null,
    //         type: type,
    //         status: "00",
    //         ann: null,
    //         inCondition: null,
    //         outCondition: null,
    //         inConditionExp: null,
    //         outConditionExp: null,
    //         isfallback:"0",
    //         fallback:null,
    //         executionInterface:null, //处理界面
    //         executionInterfaceparm:null,//界面启动参数
    //         // isfallback:"0",
    //         // isfallback:"0",
    //         // isfallback:"0",
    //         x: x,
    //         y: y,
    //         ishuman:"0",
    //         human:[],
    //         handling:[]};
    //     if (type==="03") { // 服务节点
    //         data.callin = []; // 服务输入参数列表
    //         data.callbackin = []; // 回调接口服务输入参数列表
    //         data.callout = []; // 服务输入参数列表
    //         data.        = []; // 回调接口服务输入参数列表
    //         data.calltype="0";
    //         data.timeout=30;
    //         data.protocol="0";
    //         data.timeoutHandling="01";
    //         data.redoTime=0;
    //         data.redoCycle="01";
    //         data.callbackUrl="";
    //     }
    //     if (type==="04") { // 脚本节点
    //         data.scripttype = "0"; // 默认脚本类型为JavaScript
    //         data.scriptcode="";//脚本内容
    //         data.callin = []; // 服务输入参数列表
    //         data.callout = []; // 回调接口服务输入参数列表
    //     }
    //     if (type==="06"){ // 任务节点
    //         data.tasktype="01";
    //         data.approvalstrategy="1";
    //         data.approvalweight="100";
    //         data.ismodiapproval="0";
    //         data.isentrust="0";
    //         data.isjump="0";
    //         data.users = [];
    //         data.overTimeoutUsers = [];
    //         data.roles = [];
    //         data.remindMode = [];
    //         data.remindTime = "01";
    //         data.remindCycle = "01";
    //         data.receiveTimeout = 0;
    //         data.receiveTimeoutHandling = "01";
    //         data.overTimeout = 0;
    //         data.overTimeoutHandling = "01";
    //         data.userrule="0";
    //     }

    //     if (type==="99"){ // 结束节点

    //         data.end="0";
    //         data.endtype="0";
    //         data.gototype="0";
    //         data.gotoInterface=null; //处理界面
    //         data.totoInterfaceparm=null;//界面启动参数


    //         data.servicecallin = []; // 服务输入参数列表
    //         data.servicecallbackin = []; // 回调接口服务输入参数列表
    //         data.servicecallout = []; // 服务输入参数列表
    //         data.servicecallbackout = []; // 回调接口服务输入参数列表
    //         data.servicecalltype="0";
    //         data.servicetimeout=30;
    //         data.serviceprotocol="0";
    //         data.servicetimeoutHandling="01";
    //         data.serviceredoTime=0;
    //         data.serviceredoCycle="01";
    //         data.servicecallbackUrl="";


    //         data.scripttype = "0"; // 默认脚本类型为JavaScript
    //         data.scriptcode="";//脚本内容
    //         data.scriptcallin = []; // 服务输入参数列表
    //         data.scriptcallout = []; // 回调接口服务输入参数列表
    //     }
    //     return data;

    // }

    newData(node, type) {
        var x = 50; var y = 30;
        if (node) {
            x = node.x + 150;
            if (node.data.childNode) { y = node.y + node.data.childNode.length * 90; } else { y = node.y; }
        }
        var data = {
            id: this.maxid++,
            name: null,
            type: type,
            status: "00",
            ann: null,
            inCondition: null,
            outCondition: null,
            inConditionExp: null,
            outConditionExp: null,
            isfallback: "0",
            fallback: null,
            executionInterface: null, // 处理界面
            executionInterfaceparm: null, // 界面启动参数
            // isfallback:"0",
            // isfallback:"0",
            // isfallback:"0",
            x: x,
            y: y,
            ishuman: "0",
            human: [],
            handling: []
        };
        if (type === "03") { // 服务节点
            data.servicecallin = []; // 服务输入参数列表
            data.servicecallout = []; // 服务输入参数列表
            data.servicecallbackin = []; // 回调接口服务输入参数列表
            data.servicecallbackout = []; // 回调接口服务输入参数列表
            data.serviceUrl = null;
            data.servicecalltype = "0";
            data.serviceAcynctype = "0";
            data.servicetimeout = 30;
            data.serviceprotocol = "0";
            data.servicetimeoutHandling = "01";
            data.serviceredoTime = 0;
            data.serviceredoCycle = "01";
            data.servicecallbackUrl = "";
        }
        if (type === "04") { // 脚本节点
            data.scripttype = "0"; // 默认脚本类型为JavaScript
            data.scriptcode = "";// 脚本内容
            data.scriptcallin = []; // 服务输入参数列表
            data.scriptcallout = []; // 回调接口服务输入参数列表
        }
        if (type === "06") { // 任务节点
            data.tasktype = "01";
            data.approvalstrategy = "1";
            data.approvalweight = "100";
            data.ismodiapproval = "0";
            data.isentrust = "0";
            data.isjump = "0";
            data.users = [];
            data.overTimeoutUsers = [];
            data.roles = [];
            data.remindMode = [];
            data.remindTime = "01";
            data.remindCycle = "01";
            data.receiveTimeout = 0;
            data.receiveTimeoutHandling = "01";
            data.overTimeout = 0;
            data.overTimeoutHandling = "01";
            data.userrule = "0";

            data.orgkey = "";
            data.orgtype = "";
            data.rolekey = [];
        }

        if (type === "99") { // 结束节点

            data.end = "0";
            data.endtype = "0";
            data.gototype = "0";
            data.gotoInterface = null; // 处理界面
            data.totoInterfaceparm = null;// 界面启动参数


            data.serviceUrl = null;
            data.servicecallin = []; // 服务输入参数列表
            data.servicecallbackin = []; // 回调接口服务输入参数列表
            data.servicecallout = []; // 服务输入参数列表
            data.servicecallbackout = []; // 回调接口服务输入参数列表
            data.servicecalltype = "0";
            data.serviceAcynctype = "0";
            data.servicetimeout = 30;
            data.serviceprotocol = "0";
            data.servicetimeoutHandling = "01";
            data.serviceredoTime = 0;
            data.serviceredoCycle = "01";
            data.servicecallbackUrl = "";


            data.scripttype = "0"; // 默认脚本类型为JavaScript
            data.scriptcode = "";// 脚本内容
            data.scriptcallin = []; // 服务输入参数列表
            data.scriptcallout = []; // 回调接口服务输入参数列表
        }
        return data;

    }
    cvtToJson(root) {
        if (!root) { return; }
        var children = root.data.childNode;
        if (!children) { return; }
        for (var i = 0; i < children.length; i++) {
            var child = children[i].data;
            if (child.type === "06") {
                var array = [];
                var us = child.users;
                if (us) {
                    for (var j = 0; j < us.length; j++) {
                        var u = us[j];
                        array.push(u);
                    }
                    child.users = array;
                }
                var ps = child.posts;
                if (ps) {
                    array = [];
                    for (var j = 0; j < ps.length; j++) {
                        var p = ps[j];
                        array.push(p);
                    }
                    child.posts = array;
                }
            } else {
                continue;
            }
            this.cvtToJson(child);
        }
    }

    getJson(root) {
        if (!root) { root = this.state.root.data; }
        var json = {};
        json = root;
        var children = root.childNode;
        if (!children) { return json; }
        json.childNode = [];
        for (var i = 0; i < children.length; i++) {
            json.childNode.push(this.getJson(children[i]));
        }
        return json;
    }
    deleteEmptyProperty(object) {
        for (var i in object) {
            var value = object[i];
            if (typeof value === "object") {
                if (Array.isArray(value)) {
                    if (value.length == 0) {
                        delete object[i];
                        continue;
                    }
                }
                this.deleteEmptyProperty(value);
                if (this.isEmpty(value)) {
                    delete object[i];
                }
            } else {
                if (value === "" || value === null || value === undefined) {
                    delete object[i];
                } else {
                }
            }
        }
    }


    isEmpty(object) {
        for (var name in object) {
            return false;
        }
        return true;
    }
    getData() {
        let json = this.getJson();
        // this.deleteEmptyProperty(json);
        Modal.info({
            title: "This is a notification message",
            content: JSON.stringify(json),
            onOk() { },
        });
    }
}

export default Workflow;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiFlow/Workflow/Workflow.js